import { Route } from '@angular/router';
import { LoginGuard } from '../../guards/login-guard/login-guard';

export const loginRoute: Route = {
  path: 'login',
  loadChildren: () => import('../../../components/login/login.module').then(m => m.LoginModule),
  canActivate: [LoginGuard],
};
